
const state = {
  id: null,
  campaign_id: undefined,
  contact_id: undefined,
  contact_type: '',
}

export const requiredFields = [
  { key: 'campaign_id' },
  { key: 'contact_id' },
]

export default state
